module.exports = __webpack_public_path__ + "img/pcr3.91108d9f.png";